import { jsx } from "react/jsx-runtime";
import { TextField, TextFieldTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useRef, useCallback } from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { useForcedState, ForcedState } from "../../contexts/forced-state-context.js";
import { classes } from "../../ui/text-input-field/text-input-field-wut.st.css";
const TextInputWUT = ({
  label,
  placeholder,
  required = false,
  value = "",
  onChange,
  onBlur,
  onFocus,
  type = "text",
  disabled = false,
  readOnly,
  prefix,
  inputId,
  fieldId,
  ariaDescribedBy,
  hasError,
  className,
  dataHook,
  showPasswordTooltipText,
  hidePasswordTooltipText
}) => {
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const inputRef = useRef(null);
  useFocusFieldEvent(() => {
    inputRef.current?.focus({ preventScroll: true });
  }, fieldId);
  const handleChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      onChange(newValue);
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ref: inputRef,
      id: inputId,
      type,
      error: hasError,
      newErrorMessage: true,
      value: value ? String(value) : "",
      className: classNames(classes.textField, classes.theme, className, {
        [classes.error]: hasError,
        [classes.hover]: forcedHover
      }),
      prefix,
      onChange: handleChange,
      required,
      disabled,
      placeholder,
      onBlur,
      onFocus,
      "aria-label": label,
      theme: TextFieldTheme.Box,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": hasError,
      readOnlyCustom: readOnly,
      "data-hook": dataHook,
      showPasswordTooltipText,
      hidePasswordTooltipText
    }
  );
};
export {
  TextInputWUT
};
//# sourceMappingURL=text-input-wut.js.map
